// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"Logo_headerLogo__Tsp4R","coreLogo":"Logo_coreLogo__gcQnO","economyLogo":"Logo_economyLogo__W8_p_","hiddenText":"Logo_hiddenText__P_uZW"};